import { getURL, URL_TYPES } from '@voicekey/api/http'
import { action, observable, makeObservable } from 'mobx'
import { SESSION_API } from '@voicekey/api/session/session'
import dynamicMessages from 'locales/dynamicMessages'

export class DomainStore {
  constructor (rootStore) {
    makeObservable(this, {
      _domainsList: observable,
      getDomainsList: action,
      _domainId: observable
    })

    this.rootStore = rootStore
  }

  _domainsList = null

  get domainsList () {
    return this._domainsList
  }

  set domainsList (domainsList) {
    domainsList.push({ id: -15, name: 'Root domain' })
    this._domainsList = domainsList
  }

  async getDomainsList () {
    try {
      const response = await SESSION_API.getDomains(getURL(URL_TYPES.SESSION))
      this.domainsList = response.data
    } catch (e) {
      this.rootStore.messagesStore.setMessage({ ...dynamicMessages.domains_get_fail, info: e })
      this.domainsList = []
    }
  }

  _domainId = null

  get domainId () {
    return this._domainId
  }

  set domainId (value) {
    this._domainId = value
  }
}
